<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un produit de stock..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-table px-3"></i>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
  <ng-container matColumnDef="nom">
    <th mat-header-cell *matHeaderCellDef> Nom </th>
    <td mat-cell *matCellDef="let element"> {{ element.nom }} </td>
  </ng-container>

  <!-- Type de produit -->
  <ng-container matColumnDef="typeProduit">
    <th mat-header-cell *matHeaderCellDef> Type </th>
    <td mat-cell *matCellDef="let element"> {{ element.typeProduit }} </td>
  </ng-container>

  <!-- Unité -->
  <ng-container matColumnDef="unite">
    <th mat-header-cell *matHeaderCellDef> Unité </th>
    <td mat-cell *matCellDef="let element"> {{ element.unite }} </td>
  </ng-container>
    <ng-container matColumnDef="seuilAlertePeremption">
    <th mat-header-cell *matHeaderCellDef> Seuil </th>
    <td mat-cell *matCellDef="let element"> {{ element.seuilAlertePeremption }} </td>
  </ng-container>
  
  <ng-container matColumnDef="quantite">
    <th mat-header-cell *matHeaderCellDef> Quantité </th>
    <td mat-cell *matCellDef="let element"> {{ element.quantite }} </td>
  </ng-container>

  <!-- Condition de stockage -->
  <ng-container matColumnDef="conditionStockage">
    <th mat-header-cell *matHeaderCellDef> Condition </th>
    <td mat-cell *matCellDef="let element"> {{ element.conditionStockage }} </td>
  </ng-container>

  <!-- Température -->
  <ng-container matColumnDef="temperatureStockage">
    <th mat-header-cell *matHeaderCellDef> Température </th>
    <td mat-cell *matCellDef="let element"> {{ element.temperatureStockage }} </td>
  </ng-container>

  <!-- Lot -->
  <ng-container matColumnDef="numeroLot">
    <th mat-header-cell *matHeaderCellDef> Lot </th>
    <td mat-cell *matCellDef="let element"> {{ element.numeroLot }} </td>
  </ng-container>

  <!-- Fournisseur -->
  <ng-container matColumnDef="fournisseurId">
    <th mat-header-cell *matHeaderCellDef> Fournisseur </th>
    <td mat-cell *matCellDef="let element"> {{ element.fournisseurNom }} </td>
  </ng-container>

  <!-- Localisation -->
  <ng-container matColumnDef="emplacementId">
    <th mat-header-cell *matHeaderCellDef> Localisation </th>
    <td mat-cell *matCellDef="let element"> {{ element.emplacementNom }} </td>
  </ng-container>

  <!-- Stabilité -->
  <ng-container matColumnDef="stabiliteApresOuverture">
    <th mat-header-cell *matHeaderCellDef> Stabilité (j) </th>
    <td mat-cell *matCellDef="let element"> {{ element.stabiliteApresOuverture }} </td>
  </ng-container>

  <!-- Dangerosité -->
  <ng-container matColumnDef="dangerosite">
    <th mat-header-cell *matHeaderCellDef> Dangerosité </th>
    <td mat-cell *matCellDef="let element"> {{ element.dangerosite }} </td>
  </ng-container>
    <ng-container matColumnDef="dateOuverture">
    <th mat-header-cell *matHeaderCellDef> Date d'ouverture </th>
    <td mat-cell *matCellDef="let element"> {{ element.dateOuverture }} </td>
  </ng-container>
<ng-container matColumnDef="documentPath">
  <th mat-header-cell *matHeaderCellDef> Document(s) </th>
  <td mat-cell *matCellDef="let element">
<ng-container *ngFor="let doc of element.documentPath">
      <div>
        <a [href]="getDocumentUrl(doc)" target="_blank" rel="noopener noreferrer">
          {{ doc.split('/').pop() }}
        </a>
      </div>
    </ng-container>
  </td>
</ng-container>



      <ng-container matColumnDef="dateCreation">
    <th mat-header-cell *matHeaderCellDef> Date de Création </th>
    <td mat-cell *matCellDef="let element"> {{ element.dateCreation }} </td>
  </ng-container>
    <ng-container matColumnDef="datePeremption">
    <th mat-header-cell *matHeaderCellDef> Date de péremtion </th>
    <td mat-cell *matCellDef="let element"> {{ element.datePeremption }} </td>
  </ng-container>
      <ng-container matColumnDef="dateFabrication">
    <th mat-header-cell *matHeaderCellDef> Date de Fabrication </th>
    <td mat-cell *matCellDef="let element"> {{ element.dateFabrication }} </td>
  </ng-container>

    <ng-container matColumnDef="dateModification">
    <th mat-header-cell *matHeaderCellDef> Date de mise à jour </th>
    <td mat-cell *matCellDef="let element"> {{ element.dateModification }} </td>
  </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>

                    <div *ngIf="!loadingTable">
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="15">Aucun résultat trouvé pour "{{ input.value }}"</td>
                        </tr>
                    </div>

                </table>

                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>


</mat-card>
<ng-template #content let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">
          Nouveau Produit
        </h5>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
<form [formGroup]="form" (ngSubmit)="saveProduct()">
  <div class="row">

    <!-- Nom du produit -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Nom</mat-label>
        <input matInput formControlName="nom" placeholder="Ex. Acide Nitrique">
        <mat-error *ngIf="form.get('nom')?.hasError('required')">Le nom est obligatoire</mat-error>
      </mat-form-field>
    </div>

    <!-- Type du produit -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Type Produit</mat-label>
        <mat-select formControlName="typeProduit" required>
          <mat-option *ngFor="let tp of typeProduits" [value]="tp">
            {{ tp }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('typeProduit')?.hasError('required')">Le type est obligatoire</mat-error>
      </mat-form-field>
    </div>
<div class="col-sm-12 mb-3">
  <label for="fileUpload" class="form-label">Documents (fichiers)</label>
  <input
    id="fileUpload"
    type="file"
    multiple
    (change)="handleFileChange($event)"
    accept=".pdf,.doc,.docx,.jpg,.png"
    class="form-control"
  />
</div>



    <!-- Date d'ouverture -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25 w-100">
        <mat-label>Date d'ouverture</mat-label>
        <input matInput [matDatepicker]="pickerOuverture" formControlName="dateOuverture">
        <mat-datepicker-toggle matSuffix [for]="pickerOuverture"></mat-datepicker-toggle>
        <mat-datepicker #pickerOuverture></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Date de péremption -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25 w-100">
        <mat-label>Date de péremption</mat-label>
        <input matInput [matDatepicker]="pickerPeremption" formControlName="datePeremption">
        <mat-datepicker-toggle matSuffix [for]="pickerPeremption"></mat-datepicker-toggle>
        <mat-datepicker #pickerPeremption></mat-datepicker>
      </mat-form-field>
      
    </div>
        <div class="col-sm-6">
      <mat-form-field class="mb-25 w-100">
        <mat-label>Date de fabrication</mat-label>
        <input matInput [matDatepicker]="pickerFabrication" formControlName="dateFabrication">
        <mat-datepicker-toggle matSuffix [for]="pickerFabrication"></mat-datepicker-toggle>
        <mat-datepicker #pickerFabrication></mat-datepicker>
      </mat-form-field>
    </div>


    <!-- Unité -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Unité</mat-label>
        <input matInput formControlName="unite" placeholder="Ex. mL, g, L...">
        <mat-error *ngIf="form.get('unite')?.hasError('required')">L'unité est obligatoire</mat-error>
      </mat-form-field>
    </div>

<div class="col-sm-6">
  <mat-form-field class="mb-25" appearance="fill">
    <mat-label>Seuil (en jours)</mat-label>
    <mat-select formControlName="seuilAlertePeremption" placeholder="Sélectionnez un seuil">
      <mat-option *ngFor="let seuil of seuils" [value]="seuil.value">
        {{ seuil.label }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="form.get('seuilAlertePeremption')?.hasError('required')">
      Le seuil est obligatoire
    </mat-error>
  </mat-form-field>
</div>

    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Quantité</mat-label>
        <input matInput formControlName="quantite" placeholder="Ex. 2">
        <mat-error *ngIf="form.get('quantite')?.hasError('required')">La quantité est obligatoire</mat-error>
      </mat-form-field>
    </div>
    <!-- Lot -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Lot</mat-label>
        <input matInput formControlName="numeroLot" placeholder="Ex. 2025-R01">
        <mat-error *ngIf="form.get('numeroLot')?.hasError('required')">Le numéro de lot est obligatoire</mat-error>
      </mat-form-field>
    </div>

    <!-- Température de stockage -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Température de stockage</mat-label>
        <input matInput formControlName="temperatureStockage" placeholder="Ex. 2-8°C">
      </mat-form-field>
    </div>

    <!-- Condition de stockage -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Condition de stockage</mat-label>
        <input matInput formControlName="conditionStockage" placeholder="Ex. À l'abri de la lumière">
      </mat-form-field>
    </div>

    <!-- Dangerosité -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Dangerosité</mat-label>
        <input matInput formControlName="dangerosite" placeholder="Ex. classification CLP, H phrases...">
      </mat-form-field>
    </div>

    <!-- Stabilité après ouverture -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Stabilité après ouverture (en jours)</mat-label>
        <input type="number" matInput formControlName="stabiliteApresOuverture" placeholder="Ex. 30">
      </mat-form-field>
    </div>

    <!-- Fournisseur -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Fournisseur</mat-label>
        <mat-select formControlName="fournisseurId">
          <mat-option *ngFor="let f of fournisseurs" [value]="f.id">{{ f.nom }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('fournisseurId')?.hasError('required')">Le fournisseur est obligatoire</mat-error>
      </mat-form-field>
    </div>

    <!-- Emplacement -->
    <div class="col-sm-6">
      <mat-form-field class="mb-25" appearance="fill">
        <mat-label>Emplacement</mat-label>
        <mat-select formControlName="emplacementId">
          <mat-option *ngFor="let loc of localisations" [value]="loc.id">{{ loc.nom }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('emplacementId')?.hasError('required')">L'emplacement est obligatoire</mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-12 text-right">
      <button type="submit" class="btn btn-success btn-sm">Sauvegarder</button>
    </div>
  </div>
</form>

    </mat-card-content>
  </mat-card>
</ng-template>
<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">
          Modifier Produit
        </h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="editForm" (ngSubmit)="updateProduct()">
        <div class="row">
          <!-- Nom -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Nom</mat-label>
              <input matInput formControlName="nom" placeholder="Ex. Éthanol">
              <mat-error *ngIf="editForm.get('nom')?.hasError('required')">Le nom est obligatoire</mat-error>
            </mat-form-field>
          </div>
          <!-- Bloc fichiers existants -->
          <div class="col-12 mb-3">
  <label class="form-label fw-semibold">📎 Fichiers existants</label>
  <div *ngIf="editForm.get('documentPath')?.value?.length > 0; else noFiles">
    <mat-list dense>
      <mat-list-item *ngFor="let path of editForm.get('documentPath')?.value; let i = index" class="d-flex justify-content-between align-items-center">
        <a [href]="getDocumentUrl(path)" target="_blank" rel="noopener noreferrer" class="fw-bold text-primary" style="font-size: 16px;">
          {{ path.split('/').pop() }}
        </a>
        <button mat-icon-button color="warn" aria-label="Supprimer fichier" (click)="removeDocument(i)">
          <i class="material-symbols-outlined text-danger">delete</i>
        </button>
      </mat-list-item>
    </mat-list>
  </div>
  <ng-template #noFiles>
    <p class="text-muted fst-italic">Aucun fichier associé.</p>
  </ng-template>
</div>


          <!-- Upload de nouveaux fichiers -->
          <div class="col-sm-12 mb-4">
            <label for="newFiles" class="form-label fw-semibold">➕ Ajouter des fichiers</label>
            <input
              id="newFiles"
              type="file"
              multiple
              (change)="handleFileChange($event)"
              class="form-control"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
            />
            <small class="form-text text-muted">Formats acceptés : PDF, DOC, XLS, PNG, JPG</small>
          </div>



          <!-- Type de produit -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Type de produit</mat-label>
              <mat-select formControlName="typeProduit" required>
                <mat-option *ngFor="let type of typeProduits" [value]="type">{{ type }}</mat-option>
              </mat-select>
              <mat-error *ngIf="editForm.get('typeProduit')?.hasError('required')">Type requis</mat-error>
            </mat-form-field>
          </div>
          
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Date d'ouverture</mat-label>
              <input matInput [matDatepicker]="pickerOuverture1" formControlName="dateOuverture" placeholder="JJ/MM/AAAA">
              <mat-datepicker-toggle matSuffix [for]="pickerOuverture1"></mat-datepicker-toggle>
              <mat-datepicker #pickerOuverture1></mat-datepicker>
            </mat-form-field>
            </div>
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Date de péremption</mat-label>
              <input matInput [matDatepicker]="pickerPeremption1" formControlName="datePeremption" placeholder="JJ/MM/AAAA">
              <mat-datepicker-toggle matSuffix [for]="pickerPeremption1"></mat-datepicker-toggle>
              <mat-datepicker #pickerPeremption1></mat-datepicker>
            </mat-form-field>
            </div>
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
            <mat-label>Date de fabrication</mat-label>
            <input matInput [matDatepicker]="pickerFabrication1" formControlName="dateFabrication" placeholder="JJ/MM/AAAA">
            <mat-datepicker-toggle matSuffix [for]="pickerFabrication1"></mat-datepicker-toggle>
            <mat-datepicker #pickerFabrication1></mat-datepicker>
          </mat-form-field>
          </div>

          <!-- Unité -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Unité</mat-label>
              <input matInput formControlName="unite" placeholder="Ex. mL, g, unité">
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Seuil</mat-label>
              <input matInput formControlName="seuilAlertePeremption" placeholder="Ex.15,30,60">
            </mat-form-field>
          </div>
          
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Quantité</mat-label>
              <input matInput formControlName="quantite" placeholder="Ex. 2">
            </mat-form-field>
          </div>


          <!-- Lot -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Lot</mat-label>
              <input matInput formControlName="numeroLot" placeholder="Ex. LOT2024A">
            </mat-form-field>
          </div>

          <!-- Condition de stockage -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Condition de stockage</mat-label>
              <input matInput formControlName="conditionStockage" placeholder="Ex. Température ambiante">
            </mat-form-field>
          </div>

          <!-- Température de stockage -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Température de stockage</mat-label>
              <input matInput formControlName="temperatureStockage" placeholder="Ex. 2-8°C">
            </mat-form-field>
          </div>

          <!-- Dangerosité -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Dangerosité</mat-label>
              <input matInput formControlName="dangerosite" placeholder="Ex. H225, H319">
            </mat-form-field>
          </div>


          <!-- Stabilité après ouverture -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Stabilité après ouverture (jours)</mat-label>
              <input matInput type="number" formControlName="stabiliteApresOuverture">
            </mat-form-field>
          </div>

          <!-- Fournisseur -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Fournisseur</mat-label>
              <mat-select formControlName="fournisseurId">
                <mat-option *ngFor="let f of fournisseurs" [value]="f.id">{{ f.nom }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Emplacement -->
          <div class="col-sm-6">
            <mat-form-field class="mb-25 w-100">
              <mat-label>Emplacement</mat-label>
              <mat-select formControlName="emplacementId">
                <mat-option *ngFor="let e of localisations" [value]="e.id">{{ e.nom }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Bouton Sauvegarde -->
          <div class="col-sm-12 text-right">
            <button type="submit" mat-raised-button color="primary">Sauvegarder</button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>


<ng-template #viewModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-content>
      <div class="row">
        <h5 class="px-3 fw-bold">Détails du produit :</h5>

        <!-- Nom -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Nom :</div>
          <p>{{ prd?.nom }}</p>
        </div>

        <!-- Type de produit -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Type :</div>
          <p>{{ prd?.typeProduit }}</p>
        </div>


        <!-- Unité -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Unité :</div>
          <p>{{ prd?.unite }}</p>
        </div>
     <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Unité :</div>
          <p>{{ prd?.quantite }}</p>
        </div>
        <!-- Lot -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Lot :</div>
          <p>{{ prd?.numeroLot }}</p>
        </div>

        <!-- Température de stockage -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Température de stockage :</div>
          <p>{{ prd?.temperatureStockage }}</p>
        </div>

        <!-- Condition de stockage -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Condition de stockage :</div>
          <p>{{ prd?.conditionStockage }}</p>
        </div>

        <!-- Dangerosité -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Dangerosité :</div>
          <p>{{ prd?.dangerosite }}</p>
        </div>

        <!-- Stabilité après ouverture -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Stabilité après ouverture (jours) :</div>
          <p>{{ prd?.stabiliteApresOuverture }}</p>
        </div>

        <!-- Emplacement -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Emplacement :</div>
          <p>{{ prd?.emplacementNom }}</p>
        </div>
<div class="col-lg-8 border-top p-3">
  <div class="fw-bold">Documents :</div>
  <div>
    <ng-container *ngFor="let doc of prd?.documentPath; let last = last">
      {{ doc }}
      <a [href]="getDocumentUrl(doc)" target="_blank" rel="noopener noreferrer">
        {{ doc.split('/').pop() }}
      </a>
    </ng-container>
    
  </div>
</div>


</div>
</mat-card-content>

  </mat-card>
</ng-template>






<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
